export default __webpack_public_path__ + "shape_outlines.621299ec.svg";